function MGSurface({ children }) {
  return <div className="surface --mg-effect-shadow-level1">{children}</div>;
}

MGSurface.propTypes = {};

export default MGSurface;
